import { render, staticRenderFns } from "./CommonAiiTaskDetail.vue?vue&type=template&id=a5ac2428&"
import script from "./CommonAiiTaskDetail.vue?vue&type=script&lang=tsx&"
export * from "./CommonAiiTaskDetail.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports